import styled from 'styled-components'

import {Config} from 'src/config'
import {Loader} from '../common'
import {PageContent} from './PageContent'

interface Props {
  loadingLabel?: string
  title?: string
}

const LOADING_LABEL = 'Sæki …'

const LoaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 80vh;
`

export const PageLoading = ({
  title = Config.title,
  loadingLabel = LOADING_LABEL,
}: Props): JSX.Element => (
  <PageContent label={loadingLabel} title={title}>
    <LoaderWrapper>
      <Loader />
    </LoaderWrapper>
  </PageContent>
)
